import { Amplify } from 'aws-amplify';
import { COGNITO_CONFIG, S3_CONFIG } from '../../config/partner';

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: COGNITO_CONFIG.USER_POOL_ID,
        userPoolClientId: COGNITO_CONFIG.CLIENT_ID,
        identityPoolId: COGNITO_CONFIG.IDENTITY_POOL_ID,
        loginWith: {
          oauth: {
            domain: COGNITO_CONFIG.DOMAIN,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [window.location.origin + '/auth/callback'],
            redirectSignOut: [window.location.origin],
            responseType: 'code'
          }
        }
      }
    },
    Storage: {
      S3: {
        bucket: S3_CONFIG.BUCKET_NAME,
        region: S3_CONFIG.REGION,
      }
    }
  });
}; 